export const saveRef = (code, days) => {
  const expires = new Date(Date.now() + days * 86400000);
  document.cookie = `agi_ref=${encodeURIComponent(code)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  localStorage.setItem("agi_ref", JSON.stringify({ code, expires: expires.toISOString() }));
  sessionStorage.setItem("agi_ref_fresh", "1");
};

export const readRef = () => {
  const m = document.cookie.match(/(?:^|;\s*)agi_ref=([^;]+)/);
  if (m) return { code: decodeURIComponent(m[1]), via: sessionStorage.getItem("agi_ref_fresh") ? "link" : "cookie" };
  try {
    const s = JSON.parse(localStorage.getItem("agi_ref") || "null");
    if (s?.code && new Date(s.expires) > new Date()) return { code: s.code, via: "cookie" };
  } catch { /* noop */ }
  return null;
};
